import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useSEO() {
  const [seo, setSEO] = useState(null);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await axios.get(`${API}/seo/public`);
        setSEO(response.data);
        
        // Apply SEO settings
        if (response.data) {
          // Title
          if (response.data.site_title) {
            document.title = response.data.site_title;
          }
          
          // Meta description
          let metaDesc = document.querySelector('meta[name="description"]');
          if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.name = 'description';
            document.head.appendChild(metaDesc);
          }
          metaDesc.content = response.data.site_description || '';
          
          // Meta keywords
          if (response.data.meta_keywords) {
            let metaKeywords = document.querySelector('meta[name="keywords"]');
            if (!metaKeywords) {
              metaKeywords = document.createElement('meta');
              metaKeywords.name = 'keywords';
              document.head.appendChild(metaKeywords);
            }
            metaKeywords.content = response.data.meta_keywords;
          }
          
          // Open Graph
          const ogTags = {
            'og:title': response.data.og_title || response.data.site_title,
            'og:description': response.data.og_description || response.data.site_description,
            'og:image': response.data.og_image
          };
          
          Object.entries(ogTags).forEach(([property, content]) => {
            if (content) {
              let ogTag = document.querySelector(`meta[property="${property}"]`);
              if (!ogTag) {
                ogTag = document.createElement('meta');
                ogTag.setAttribute('property', property);
                document.head.appendChild(ogTag);
              }
              ogTag.content = content;
            }
          });
          
          // Favicon
          if (response.data.favicon_url) {
            let favicon = document.querySelector('link[rel="icon"]');
            if (!favicon) {
              favicon = document.createElement('link');
              favicon.rel = 'icon';
              document.head.appendChild(favicon);
            }
            favicon.href = response.data.favicon_url;
          }
        }
      } catch (error) {
        console.log("SEO settings not available");
      }
    };
    
    fetchSEO();
  }, []);
  
  return seo;
}

export default useSEO;
